export * from './domain';
export * from './dto';
export * from './builders';
export var createCallCenterInsightsApi = function (baseUrl, http) {
    var url = "".concat(baseUrl, "/analytics/callCenter");
    return {
        getOverview: function (dto) { return http.post("".concat(url, "/overview"), dto); },
        getCallVolumeCumulative: function (dto) { return http.post("".concat(url, "/callVolume/cumulative"), dto); },
        getCallVolumeHistogram: function (dto) { return http.post("".concat(url, "/callVolume/histogram"), dto); },
        getWaitTimeCumulative: function (dto) { return http.post("".concat(url, "/waitTime/cumulative"), dto); },
        getWaitTimeHistogram: function (dto) { return http.post("".concat(url, "/waitTime/histogram"), dto); },
        getHandleTimeCumulative: function (dto) { return http.post("".concat(url, "/handleTime/cumulative"), dto); },
        getHandleTimeHistogram: function (dto) { return http.post("".concat(url, "/handleTime/histogram"), dto); },
        getAbandonRateCumulative: function (dto) { return http.post("".concat(url, "/abandonRate/cumulative"), dto); },
        getAbandonRateHistogram: function (dto) { return http.post("".concat(url, "/abandonRate/histogram"), dto); },
        getSatisfactionScoreCumulative: function (dto) { return http.post("".concat(url, "/satisfactionScore/cumulative"), dto); },
        getSatisfactionScoreHistogram: function (dto) { return http.post("".concat(url, "/satisfactionScore/histogram"), dto); },
        getQueueTransfersData: function (dto) { return http.post("".concat(url, "/transfers"), dto); },
        getOverviewMetrics: function (dto) { return http.post("".concat(url, "/overview/metrics"), dto); },
        getServiceLevelData: function (dto) { return http.post("".concat(url, "/serviceLevel"), dto); },
    };
};
//# sourceMappingURL=index.js.map